var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[(_vm.action > 0)?_c('h2',{style:(`color:lime`)},[_vm._v("x"+_vm._s(_vm.action / _vm.value))]):_vm._e(),(_vm.action < 1)?_c('h2',{style:(`color:#ff6b6b`)},[_vm._v("x0")]):_vm._e(),(_vm.value)?_c('h4',[_vm._v(" "+_vm._s(_vm._f("formatMoney")(_vm.value))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }